import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { getGameReconciliationLedger } from 'services/scratcherService';
import type { GameLedgerPeriodDays, GameReconciliationLedgerResponse } from 'features/scratchers/types';
import { getLedgerDateRange } from '../../utils/gameLedgerDateRange';

export function useGameAuditLedger(
  storeId: string | null | undefined,
  gameId: string | null | undefined,
  days: GameLedgerPeriodDays = 30,
  timeZone?: string | null,
  enabled = true,
) {
  const { startDate, endDate } = useMemo(
    () => getLedgerDateRange(days, timeZone),
    [days, timeZone],
  );

  return useQuery<GameReconciliationLedgerResponse>({
    queryKey: ['game-reconciliation-ledger', storeId, gameId, startDate, endDate],
    queryFn: () => getGameReconciliationLedger(storeId!, gameId!, startDate, endDate),
    enabled: Boolean(enabled && storeId && gameId),
  });
}
